module.exports = __webpack_public_path__ + "img/partner5.f1107653.png";